import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { getLoginStateSelector } from '../../../../../redux/selectors/loginSelector'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import Loader from '../../../../../components/loader/loader'
import { allRoutes } from '../../../../../utils/routeConstants'
import { useDispatch } from 'react-redux'
import { getRiskAssessmentsById } from '../../../../../redux/risk-assessment/riskAssessmentSlice'
import { getRiskAssessmentLoadingState } from '../../../../../redux/selectors/riskAssessment'
import { getTaskDetail, setScrollPosition } from '../../../../../redux/risk-assessment-core/riskAssessmentCoreSlice'
import { sessionAttributes, setItemInSession } from '../../utils/sessionStorage'

export default function ShareEventDetails() {
    const [riskAssessmentData, setRiskAssessmentData] = useState('')
    const loginState = useSelector(getLoginStateSelector())
    const loadingState = useSelector(getRiskAssessmentLoadingState())
    const params = useParams()
    const nav = useNavigate()
    const dispatch = useDispatch()
    const location = useLocation()
    
    // Extract data from query parameters
    const searchParams = new URLSearchParams(location.search)
    const eventId = searchParams.get('eventId')
    const riskAssessmentId = searchParams.get('riskAssessmentId')
    const eventName = searchParams.get('eventName') 
    const scrollPosition = searchParams.get('scrollPosition') || 0 


    // Fetch data when component mounts
    useEffect(() => {
        if (riskAssessmentId) {
            fetchRiskAssessmentAndTaskData()
        }
    }, [riskAssessmentId])

    // Handle navigation after data is loaded

    useEffect(() => {

        console.log(riskAssessmentData)

        if ( riskAssessmentData  && eventId && eventName) {
            const selectedProductLine = riskAssessmentData?.product_detail

            if (loginState.isLoggedIn && loginState.token) {
                setItemInSession(
                    sessionAttributes.selectedProductLine,
                    JSON.stringify(selectedProductLine),
                  );
                nav(allRoutes.dashboardRoutes.assessmentRoutes.eventDetails, {
                  state: {
                    ...location.state,
                    selectedEventName: eventName,
                    eventId: eventId,
                    selectedTask: riskAssessmentData?.task_detail?.[0],
                    scrollPosition: parseInt(scrollPosition),
                    selectedRiskAssessment: riskAssessmentData,
                    selectedProductLine: selectedProductLine,
                    selectedModelId: riskAssessmentData?.machine_detail?.[0]?.id,
                    selectedModel: riskAssessmentData?.machine_detail?.[0],
                    type: riskAssessmentData?.type ?? 1
                  },
                });
            } else {
                nav(allRoutes.login, {
                    state: {
                        lastNavLink: window.location.href,
                        selectedEventName: eventName,
                        eventId: eventId,
                        selectedTask: riskAssessmentData?.task_detail?.[0],
                        scrollPosition: parseInt(scrollPosition),
                        selectedRiskAssessment: riskAssessmentData,
                        selectedProductLine: selectedProductLine,
                        selectedModelId: riskAssessmentData?.machine_detail?.[0]?.id,
                        selectedModel: riskAssessmentData?.machine_detail?.[0],
                        type: riskAssessmentData?.type ?? 1
                    }
                })
            }
        }
    }, [riskAssessmentData, eventId, eventName])

    const fetchRiskAssessmentAndTaskData = () => {



        // Fetch Risk Assessment Data
        if (riskAssessmentId) {
            dispatch(getRiskAssessmentsById({
                id: riskAssessmentId, 
                callback: (result) => {
                    setRiskAssessmentData(result.data)
                }
            }))
        }

    }




    return (
        <div>
            {loadingState && <Loader />}
            {!riskAssessmentId && (
                <div style={{ padding: '20px', textAlign: 'center' }}>
                    <p>No risk assessment ID provided in query parameters</p>
                </div>
            )}
 
            {!eventId && (
                <div style={{ padding: '20px', textAlign: 'center' }}>
                    <p>No event ID provided in query parameters</p>
                </div>
            )}
            {!eventName && (
                <div style={{ padding: '20px', textAlign: 'center' }}>
                    <p>No event name provided in query parameters</p>
                </div>
            )}
        </div>
    )
}
